import { HistoryTable } from "../history-table"
import ReactDropdown from 'rc-dropdown'
import HistorySvg from '@/shared/assets/images/Bank.svg'

export const HistoryDropdown = () => {
    return (
        <ReactDropdown
            overlay={(
                <HistoryTable />
            )}
            trigger={['click']}
        >
            <button className={'rounded-2xl hover:bg-black/5 screen:rounded-3xl transition-all ease-in gap-3 bg-white w-full px-4 py-5 screen:px-6 screen:py-7 flex items-center'}>
                <div className={'bg-color-dark overflow-hidden transition-all ease-in rounded-full w-[56px] h-[56px] flex items-center justify-center text-color-primary'}>
                    <div className="fill-color-dark text-color-primary">
                        <HistorySvg width={32} height={32} />
                    </div>
                </div>
                <div className={'text-color-base transition-all ease-in'}>
                    <div className='text-2xl screen:text-[32px] leading-[24px] font-mediumttf screen:leading-[32px] font-semibold'>ИСТОРИЯ</div>
                </div>
            </button>
        </ReactDropdown >
    )
}